import { Title } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import type { JSX } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMutation } from "urql";
import {
    type TtsProjectCreateMutation,
    type TtsProjectCreateMutationVariables,
    ttsProjectCreateMutation,
} from "./queries";
import TtsProjectForm, { type IFormValues } from "./TtsProjectForm";

function Add(): JSX.Element {
    const navigate = useNavigate();
    const [addResult, executeAdd] = useMutation<TtsProjectCreateMutation, TtsProjectCreateMutationVariables>(
        ttsProjectCreateMutation,
    );

    const handleSubmit = async (values: IFormValues) => {
        const result = await executeAdd({
            data: {
                name: values.name,
                text: values.text,
                voice: values.voice,
                instructions: values.instructions || null,
            },
        });
        if (result.error) {
            notifications.show({
                title: "Failed to create TTS Project",
                message: result.error.message,
                color: "red",
            });
        } else {
            notifications.show({
                title: "TTS Project created",
                message: "Created TTS Project",
            });
            navigate(`../${result.data!.ttsProjectCreate.id}`);
        }
    };

    return (
        <>
            <Title order={2}>Create new TTS Project</Title>
            <TtsProjectForm handleSubmit={handleSubmit} fetching={addResult.fetching} />
            <Link to="..">Back</Link>
        </>
    );
}

export default Add;
